import axios from "axios";
import mainConfig from "/config";
const authentication = mainConfig.endpoint + "authentication"

export default {

    singUp(data) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        };

        let aFormData = new FormData();
        aFormData.append("sign_methods", '__up__');
        aFormData.append("data", JSON.stringify(data));

        return new Promise((resolve, reject) => {
            axios
                .post(authentication, aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    if (resp.status === 200) {
                        localStorage.account = JSON.stringify({
                            token: resp.data.token,
                            user: resp.data.user
                        })
                    } else {
                        localStorage.removeItem('account')
                    }

                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject()
                });
        });
    },

    singIn(data) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        };

        let aFormData = new FormData();
        aFormData.append("sign_methods", '__in__');
        aFormData.append("singinby", data.singinby);
        aFormData.append("password", data.password);

        return new Promise((resolve, reject) => {
            axios
                .post(authentication, aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }

                    if (resp.status === 200) {
                        localStorage.setItem('account', JSON.stringify({
                            token: resp.data.token,
                            user: resp.data.user
                        }))
                    } else {
                        localStorage.removeItem('account')
                    }


                    resolve(resp);
                })
                .catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject()
                });
        });
    },

    auth(token) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": token
            }
        };
        let aFormData = new FormData();
        aFormData.append("sign_methods", '__auth__');

        return new Promise((resolve, reject) => {
            axios
                .post(authentication, aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    if (resp.status === 200) {
                        localStorage.account = JSON.stringify({
                            token: resp.data.token,
                            user: resp.data.user,
                        })
                    } else {
                        localStorage.removeItem("account");
                    }
                    resolve(resp)

                }).catch(err => {
                    localStorage.removeItem("account");
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err)
                });
        });
    },

    validatTokenOfReset(token) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": token
            }
        };

        let aFormData = new FormData();
        aFormData.append("sign_methods", '__validat_token_of_reset__');

        return new Promise((resolve, reject) => {
            axios
                .post(authentication, aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);

                }).catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(resp)
                });
        });
    },

    validatToken(token) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": token
            }
        };

        let aFormData = new FormData();
        aFormData.append("sign_methods", '__validat_token__');

        return new Promise((resolve, reject) => {
            axios
                .post(authentication, aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp);

                }).catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(resp)
                });
        });
    },

    confirmation(data, token) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": token

            }
        };

        let aFormData = new FormData();
        aFormData.append("sign_methods", '__confemail__');
        aFormData.append("data", JSON.stringify(data));

        return new Promise((resolve, reject) => {
            axios
                .post(authentication, aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }

                    if (resp.status === 200) {
                        localStorage.setItem('account', JSON.stringify({
                            token: resp.data.token,
                            user: resp.data.user
                        }))
                    } else {
                        localStorage.removeItem('account')
                    }

                    resolve(resp)

                }).catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject()
                });
        });
    },

    forgotpassword(email) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        };

        let aFormData = new FormData();
        aFormData.append("sign_methods", '__forgot_password__');
        aFormData.append("email", email);

        return new Promise((resolve, reject) => {
            axios
                .post(authentication, aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp)

                }).catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                    reject(err)
                });
        });
    },

    resetpassword(data, token) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": token
            }
        };

        let aFormData = new FormData();
        aFormData.append("sign_methods", '__reset_password__');
        aFormData.append("data", JSON.stringify(data));

        return new Promise((resolve, reject) => {
            axios
                .post(authentication, aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    resolve(resp)

                }).catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        reject(err)
                        console.error(err)
                    }
                });
        });
    },

    signout(token) {
        let config = {
            crossdomain: true,
            headers: {
                "Content-Type": "multipart/form-data",
                "Authorization": token
            }
        };

        let aFormData = new FormData();
        aFormData.append("sign_methods", '__out__');

        return new Promise((resolve, reject) => {
            axios
                .post(authentication, aFormData, config)
                .then(resp => {
                    if (mainConfig.DEBUGMODE) {
                        console.warn(resp)
                    }
                    localStorage.removeItem('account')
                    resolve()

                }).catch(err => {
                    if (mainConfig.DEBUGMODE) {
                        console.error(err)
                    }
                });
        });
    },

}